import { currentDomain, TOKEN_COOKIE_KEY as TOKEN_KEY, DYNAMIC_ENV, WS2_HOST } from '@bfe/by-dynamic-domain';
import { isTestnet as IS_TESTNET, isProd as IS_PROD, isDev as IS_DEV,repaired_hostname } from '@bfe/by-env';
import { ram } from '@sfe/bone-cache';

/**
 * 判断是否为客户端，兼容window
 */
export const isClient = (() => typeof window !== 'undefined')();

export const { hostname = '' } = isClient ? window.location : {};

export const isTestnet = IS_TESTNET;

export const isProd = IS_PROD;

export const isDev = IS_DEV;

export const ENV = isDev ? (() => {
  const hostSplits = repaired_hostname ? repaired_hostname.split('.') : [];
  return hostSplits?.[1] || '';
})() : DYNAMIC_ENV;

/**
 * 根据获取当前环境的host
 */
export const getOnlineHost = () => {
    if (isTestnet) {
        return `testnet.${currentDomain}`;
    }
    if (isProd) {
        return `www.${currentDomain}`;
    }
    return `www.${ENV}.${currentDomain}`;
};

/**
 * 根据环境配置，获取可用的host
 */
export const onlineHost = getOnlineHost();

/**
 * Cookie token 标识
 */
export const TOKEN_COOKIE_KEY = TOKEN_KEY;

/**
 * 当前 Cookie 写入的域名
 */
export const COOKIE_MAIN_DOMAIN = (() => {
    // 目前现货项目只会在：`www.xxx` 、`testnet.xxx` 域名上运行，这里需要在运行的域名上获取主域，需要跟其它组逻辑一致
    let domain =
        hostname.indexOf('localhost') !== -1
            ? 'localhost'
            : hostname.replace(/^(www|m|testnet)/, '');

    // 适配本地开发时 `dev.bybit.com` 使用的上级域的 Cookie
    if (isDev) {
        domain = domain.replace(/^dev/, '');
    }

    return domain;
})();

// 当前环境对应域名列表
export const DOMAIN_LIST = (() => {
    const list: string[] = [];
    if (ENV === 'testnet') {
        list.push('bybitglobal.com');
    } else if (ENV === 'prd') {
        list.push('bycbe.com');
        list.push('byapis.com');
    } else {
        list.push('bybit-cn.com');
    }
    if (list.includes(currentDomain)) return list;
    list.unshift(currentDomain);
    return list;
})();

/**
 * ws接口域名列表
 */
export const WS_DOMAIN_LIST = (() => {
    const list: string[] = [];
    DOMAIN_LIST.forEach((domain) => {
        list.push(`${WS2_HOST}${domain}`);
    });
    return list;
})();

/**
 * 循环获取Origin List
 *
 * @param {string} id 调用方法的id，用来缓存循环执行的次数
 * @param {Object} options 配置参数
 * @param {Array} options.originList 域名列表
 * @param {string} options.currentOrigin 当前域名
 * @param {number} options.maxLoops 循环的最大次数
 * @return {Object}
 */
export const getUsableOrigin: any = (id, { originList = [], currentOrigin = '', maxLoops = 5 }) => {
    // 获取缓存
    let cache = ram.get(id);
    if (!cache) {
        cache = {
            times: 0, // 链路列表循环次数
            initIndex: null, // 当前链路在链路列表中的初始位置索引
        };
        if (id) {
            ram.set(id, cache);
        }
    }

    let { times, initIndex } = cache;

    // 返回值 函数
    const getValue = (isLoop = true, origin) => ({
        isLoop,
        origin,
    });

    // 没有id || 没有链路列表 || 链路列表只有一个且和当前传入的链路相同 || 循环次数 > 最大循环次数 时，返回当前传入的链路，停止循环切换新链路
    if (!id || !originList?.length || (originList?.length === 1 && originList?.[0] === currentOrigin) || times > maxLoops) {
        return getValue(false, currentOrigin);
    }

    // 新的链路
    let origin = '';

    // 获取当前链路在链路列表中的位置索引
    const index = originList.findIndex((v) => v === currentOrigin);

    // 如果 当前索引 = 初始索引，说明已经循环过一次当前链路列表，缓存中记录一次；
    if (index === initIndex) {
        times += 1;
        ram.set(id, {
            ...cache,
            times,
        });
    }

    // 如果没有缓存过，设置初始索引
    if (initIndex === null) {
        initIndex = index === -1 ? originList.length - 1 : index;
        ram.set(id, {
            ...cache,
            initIndex,
        });
    }

    if (times > maxLoops) {
        // 大于最大循环次数，取当前传入的origin
        origin = currentOrigin;
    } else if (index === originList.length - 1) {
        // 如果是最后一条，取第一条
        [origin] = originList;
    } else {
        // 循环获取
        origin = originList[index + 1];
    }

    return getValue(times < maxLoops, origin);
};

/**
 * 订单条数限制，默认拉取20条
 */
export const ORDER_LIMIT = 20;

/**
 *
 * !重要!重要!重要
 * 项目中合规的路由，在not-found中做判断使用，新增的页面路由需要添加进来
 *
 */
export const PATHS_SUPPORT = [
  '/trade/spot/pre-market', // home
  '/trade/spot/pre-market/orders', // orders
];

